export default __webpack_public_path__ + "static/media/react-bootstrap.4f4cdd1a.png";